import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router/composables'
import LocationPickerList from './LocationPickerList.vue'
import ResourcePickerList from './ResourcePickerList.vue'
import LocationPickerForJobCluster from './LocationPickerForJobCluster.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldViewPickerPanel',
  props: {
    ids: null,
    source: null
  },
  setup(__props: any) {

const props = __props as {
  ids: string
  source: string
}



const router = useRouter()

const routeIds = computed(() => props.ids?.split(','))

const parsedJobClusterData = computed(() => {
  if (!showLocationPickerForJobClusters.value) return {}
  return JSON.parse(props.ids) || {}
})

const showLocationPicker = computed(
  () => props.source === 'locations' && routeIds.value.length > 1
)

const showResourcePicker = computed(
  () => props.source === 'resources' && routeIds.value.length > 1
)

const showLocationPickerForJobClusters = computed(
  () => props.source === 'jobs-cluster' && props.ids.length > 1
)

onMounted(() => {
  if (
    !showLocationPicker.value &&
    !showResourcePicker.value &&
    !showLocationPickerForJobClusters.value
  ) {
    // if the panel is initialized in an invalid state, auto-dismiss the panel
    handleDismiss()
  }
})

function handleDismiss() {
  router.replace({ name: 'field-view-next', hash: router.currentRoute.hash })
}

return { __sfc: true,props, router, routeIds, parsedJobClusterData, showLocationPicker, showResourcePicker, showLocationPickerForJobClusters, handleDismiss, LocationPickerList, ResourcePickerList, LocationPickerForJobCluster }
}

})